import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MaskService } from '@shared/services/mask.service';

/** Seção de campos do Imposto Seletivo: CST IS, cClassTrib IS, alíquota (%) e alíquota ad rem. */
@Component({
    selector: 'app-regra-tributaria-is-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgxCurrencyDirective,
    ],
    templateUrl: './regra-tributaria-is-section.component.html',
    styleUrl: './regra-tributaria-is-section.component.css',
})
export class RegraTributariaIsSectionComponent {
    @Input({ required: true }) form!: FormGroup;

    public readonly percentMask = inject(MaskService).getPercentMask();
    public readonly currencyMask = inject(MaskService).getCurrencyMask();
}
